import React from "react";
import img from "../../images/circle.png"

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-full">
        <img src={img}   className="loader animate-spin"/>
    </div>
  );
};

export default Loader;
